module.exports = __webpack_public_path__ + "img/ro.c83a1e15.png";